<template>
    <v-container>
        <div>
            <div class="text-center">
                <p >Wie würden dich </p>
                <h1 class="mb-4 underline" style="font-family:'Pacifico',serif">Familie & Freunde</h1>
                <p>beschreiben?</p>
            </div>
            <img class="center" src="../assets/WordCloud2.png" alt="cloud"/>
            <p style="font-size:x-small" class="text-center">
                <em>Ein Wort ist nicht genug ...</em>
            </p>
        </div>
    </v-container>
</template>

<script>
    export default {
        name: "WordCloud"
    }
</script>

<style scoped>
    img.center {
        display: block;
        margin: 0 auto;
        max-width: 600px;
        width: 100%;
    }
</style>
